import { IconClose } from '@consta/icons/IconClose'
import { Button } from '@consta/uikit/Button'
import { Steps } from '@consta/uikit/Steps'
import { Text } from '@consta/uikit/Text'
import type { UploadedFileStepType } from '@core/core/types'
import { ObjectEntries } from 'common/helpers'
import type { FC } from 'react'

import css from './MasterImport.css'
import { stepsItems } from './MasterImportData'
import { StepButtons, StepComponent } from './StepComponents'
import type { MasterImportProps } from './types'

export const MasterImport: FC<MasterImportProps> = ({
  file,
  onMasterImportClose,
  onStepChanged,
  onStatusChanged,
  getFilesFromExplorer,
  updateFileConfig,
  addFilesToProject,
  removeOpenFiles,
}) => {
  if (file === undefined) return null

  const fileName = file.file?.name.slice(0, -4) ?? ''

  const onSetupNextStepClick = () => {
    file.fileId && onStepChanged(file.fileId, 'next')
  }

  const onMappingPrevStepClick = () => {
    file.fileId && onStepChanged(file.fileId, 'prev')
  }

  const onLoadingPrevStepClick = () => {
    file.fileId && onStepChanged(file.fileId, 'prev')
  }

  const onConversionPrevStepClick = () => {
    file.fileId && onStepChanged(file.fileId, 'prev')
  }

  const onReadyPrevStepClick = () => {
    file.fileId && onStepChanged(file.fileId, 'prev')
  }

  const onAddFilesToProject = () => {
    file.fileId && addFilesToProject([file.fileId])
  }

  const onLoadingResumePauseClick = (isPaused: boolean) => {
    if (!file.fileId) {
      return
    }
    if (!file.file && isPaused) {
      getFilesFromExplorer()
    } else {
      onStatusChanged(file.fileId, 'loading', isPaused ? 'inprogress' : 'paused')
    }
  }

  const onReturnDefaultValues = () => {
    file.fileId && updateFileConfig(file.fileId, file.uploadedFile?.initialSetupContent)
  }

  const activeStep: UploadedFileStepType = file.uploadedFile?.step ?? 'setup'
  const steps = ObjectEntries(stepsItems)
    // Раскомментировать если Загрузка и Конвертация - на одной вкладке
    //.filter(([step, name]) => step !== 'conversion')
    .map(([step, name]) => ({ step, name }))
    .filter(step => file.uploadedFile?.statuses?.[step.step] !== 'excluded')

  const activeStepValue = { step: activeStep, name: stepsItems[activeStep] }
  const getStepCompleted = ({ step: stepName }: { step: UploadedFileStepType }) => {
    const step = file.uploadedFile?.statuses?.[stepName]
    return step === 'ready' || step === 'succeeded'
  }
  const scrollClassName = activeStep !== 'ready' ? css.masterImportScroll : css.readyStepScroll
  const title = file.file?.name ?? file.uploadedFile?.name
  return (
    <div className={css.masterImport}>
      <div className={scrollClassName}>
        <div className={css.masterImportHeader}>
          <Text size="m" view="secondary" data-testid={title}>
            {title}
          </Text>
          <Button
            size="xs"
            view="clear"
            onlyIcon={true}
            iconLeft={() => <IconClose size="s" view="ghost" />}
            onClick={onMasterImportClose}
          />
        </div>
        <Steps
          items={steps}
          value={activeStepValue}
          getItemLabel={item => item.name}
          getItemCompleted={item => getStepCompleted(item)}
          className={css.masterImportSteps}
          onChange={() => {
            console.log('not implemented yet')
          }}
        />
        <StepComponent
          fileName={fileName}
          file={file}
          activeStep={activeStep}
          updateFileConfig={updateFileConfig}
          removeOpenFiles={removeOpenFiles}
        />
      </div>
      <div className={css.masterImportFooter}>
        <StepButtons
          uploadedFile={file.uploadedFile}
          activeStep={activeStep}
          getFilesFromExplorer={getFilesFromExplorer}
          onReturnDefaultValues={onReturnDefaultValues}
          onSetupNextStepClick={onSetupNextStepClick}
          onLoadingPrevStepClick={onLoadingPrevStepClick}
          onConversionPrevStepClick={onConversionPrevStepClick}
          onLoadingResumePauseClick={onLoadingResumePauseClick}
          onReadyPrevStepClick={onReadyPrevStepClick}
          onAddFilesToProject={onAddFilesToProject}
          onMappingPrevStepClick={onMappingPrevStepClick}
        />
      </div>
    </div>
  )
}
